import { render, staticRenderFns } from "./BannerExtraHours.vue?vue&type=template&id=992cf580&scoped=true"
import script from "./BannerExtraHours.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerExtraHours.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BannerExtraHours.vue?vue&type=style&index=0&id=992cf580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992cf580",
  null
  
)

export default component.exports